import React from "react";
import { Box, Grid, Typography, Button, Chip, Snackbar, Alert } from "@mui/material";
import FlagRoundedIcon from "@mui/icons-material/FlagRounded";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import MiniStat from "../../components/MiniStat";
import { tokens } from "../../theme";
import { riskSignals } from "../../data/mockData";

const mono = '"IBM Plex Mono", monospace';
const th = { textAlign: "left", color: tokens.textDim, fontSize: 10.5, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, padding: "10px 12px", borderBottom: `1px solid ${tokens.border}`, whiteSpace: "nowrap" };
const td = { padding: "11px 12px", borderBottom: `1px solid ${tokens.border}`, fontSize: 12.5, verticalAlign: "middle" };

export default function Risk() {
  const [snack, setSnack] = React.useState(null);
  return (
    <Box>
      <PageHeader title="Risk & Fraud" crumb="Operate / Risk & Fraud" subtitle="Abuse, chargebacks, velocity, large tx" />

      <Grid container spacing={1.75} sx={{ mb: 1.75 }}>
        <Grid item xs={6} md={3}><MiniStat label="Chargeback / failed tx" value="528" note="$574 today" color={tokens.danger} /></Grid>
        <Grid item xs={6} md={3}><MiniStat label="Velocity flags" value="1" note="PL-7781" color={tokens.amber} /></Grid>
        <Grid item xs={6} md={3}><MiniStat label="Large tx (>$200)" value="1" note="$299.99" color={tokens.amber} /></Grid>
        <Grid item xs={6} md={3}><MiniStat label="Open fraud holds" value="7" note="2 new" color={tokens.danger} /></Grid>
      </Grid>

      <SectionCard title="Open signals" subtitle="Ranked by score">
        <Box sx={{ overflowX: "auto" }}>
          <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr><th style={th}>Player</th><th style={th}>Signal</th><th style={th}>Score</th><th style={th}>Detail</th><th style={th}>Action</th></tr></thead>
            <tbody>
              {riskSignals.map((r) => (
                <tr key={r.pid}>
                  <td style={td}><div style={{ fontWeight: 600 }}>{r.p}</div><div style={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>{r.pid}</div></td>
                  <td style={td}><Chip size="small" label={r.type} sx={{ bgcolor: "rgba(242,92,102,0.13)", color: tokens.danger, fontWeight: 600, height: 20 }} /></td>
                  <td style={{ ...td, fontFamily: mono, fontWeight: 700, color: r.score > 0.8 ? tokens.danger : tokens.amber }}>{r.score}</td>
                  <td style={{ ...td, color: tokens.textDim }}>{r.detail}</td>
                  <td style={td}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button size="small" variant="outlined" startIcon={<FlagRoundedIcon />} onClick={() => setSnack(`${r.p} frozen pending investigation`)} sx={{ color: tokens.danger, borderColor: "rgba(242,92,102,0.4)" }}>Freeze</Button>
                      <Button size="small" variant="outlined" color="inherit" onClick={() => setSnack("Escalated — routed to compliance")}>Escalate</Button>
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </Box>
        </Box>
      </SectionCard>

      <Box sx={{ display: "flex", gap: 1, alignItems: "center", p: 1.5, mt: 1.75, borderRadius: "10px", borderLeft: `3px solid ${tokens.danger}`, border: `1px solid ${tokens.border}`, background: tokens.cardBg }}>
        <Typography sx={{ color: tokens.danger }}>⚑</Typography>
        <Typography variant="caption" color="text.secondary">Risk flags hard-suppress all marketing and override every other rule — including active offers and journeys.</Typography>
      </Box>

      <Snackbar open={Boolean(snack)} autoHideDuration={3000} onClose={() => setSnack(null)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert severity="warning" variant="filled" onClose={() => setSnack(null)}>{snack}</Alert>
      </Snackbar>
    </Box>
  );
}
